import { LOGIN_PERSISTENCE_BLOCK_LIST } from './constants';

// this function is capturing the URL when user hit login.
// Any login page's URL will get captured and stored in localStorage.entryPointData
// LOGIN_PERSISTENCE_BLOCK_LIST is a list of pages that should not be captured
export const getEntryPoint = () => {
  const pathnameNoLocale = window.location.pathname.slice(7);
  const customPageName = pathnameNoLocale.replace('account/', '').replace('/login', '');

  if (global.BROWSER && !LOGIN_PERSISTENCE_BLOCK_LIST.includes(customPageName)) {
    const entryPointData = {
      entryURL: window.location.href,
      entrySearchParam: window.location.search,
      entryPathName: window.location.pathname,
      entryPathNoLocale: pathnameNoLocale,
      entryOrigin: window.location.origin,
      entryURLNoSearch: window.location.origin + window.location.pathname,
    };
    localStorage.setItem('entryPointData', JSON.stringify(entryPointData));
  }
};
